import React from 'react';

function EttevottestStory() {
  return (
    <section className="relative">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 bg-gray-800 bg-opacity-40 mb-20 rounded-2xl"
      data-aos="zoom-y-out" data-aos-delay="600">
        <div className="max-w-5xl mx-auto">
          <div className="pb-12 py-12">

            <div className="max-w-3xl mx-auto">
              <h3 className="h4 mb-3 text-blue-200" 
              data-aos="zoom-y-out" data-aos-delay="600">Meie lugu</h3>
              <p className="text-xl text-gray-300 opacity-70 mb-8 whitespace-pre-wrap" 
              data-aos="zoom-y-out" data-aos-delay="600">
                <span className="font-bold">
                Tähetrükk OÜ{" "}
                </span>
                on loodud Eesti kapitalil aastal 2004. Tähetrükk OÜ põhitegevuseks on kiire ja kvaliteetne teenustrükk peamiselt 
                kleebisetikettidele. {"\n"}Kasutame uusimaid tehnoloogiaid, mis annavad kiire ja kvaliteetse tulemuse.
                Valmistame ja müüme ka erinevaid rullides kleebisetikettide toorikuid termo- ja termosiirde printeritele 
                ning kaaludele, lisaks on sortimendis termosiirde süsilindid.
              </p>
            </div>

            <div className="sm:flex">
              <figure className="flex flex-shrink-0 max-w-none sm:max-w-xs lg:max-w-none mb-8 sm:mb-0" 
              data-aos="zoom-y-out" data-aos-delay="1200">
                <img className="flex-grow self-start rounded ease-in" src={require('../images/pilt1.png').default} width="435" alt="Ettevõttest 02" />
              </figure>
              <div className="sm:ml-8 lg:ml-16">
                <h4 className="h4 mb-2 text-blue-200" 
                data-aos="zoom-y-out" data-aos-delay="800">Eesmärk</h4>
                <p className="text-xl text-gray-300 opacity-70 mb-8 whitespace-pre-wrap"
                 data-aos="zoom-y-out" data-aos-delay="800">
                  Meie eesmärk on pakkuda kiiret ja kvaliteetset trükiteenust. Tallinna piires toome tellimused tasuta kohale.
                  Kiirteenusena on võimalik kleebised kätte saada juba samal päeval.
                </p>
                <h4 className="h4 mb-2 text-blue-200" 
                data-aos="zoom-y-out" data-aos-delay="1000">Tooted</h4>
                <p className="text-xl text-gray-300 opacity-70 mb-8 whitespace-pre-wrap" 
                data-aos="zoom-y-out" data-aos-delay="1000">
                *Kleebisetiketid *Tooteinfod *EAN-koodid *Pandimärgid *Erikleebised *Plakatid *Voldikud *Süsilindid
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default EttevottestStory;